import React from 'react'
import classnames from 'classnames'
import ScrollElememt from '../../../../components/ScrollElement'
import useRandomId from '../../../../hooks/useRandomId'

import './style.scss'

interface BlockImageProps {
  onceKey?: string
  getRef?: (ref: HTMLDivElement) => void
  src: string
  hoverSrc?: string
  alt?: string
  autoOnceKey?: boolean
  className?: string
}

const BlockImage: React.FC<BlockImageProps> = ({
  onceKey,
  getRef,
  src,
  hoverSrc,
  className,
  alt,
  autoOnceKey = false,
}) => {
  const autoOnceKeyId = useRandomId()

  return (
    <ScrollElememt
      className={classnames('block-image', className)}
      activeClassName="active"
      enterClassName="enter"
      getRef={getRef}
      onceKey={onceKey ?? autoOnceKeyId}
      enterOffset={50}
    >
      <div className="wrap">
        <img src={src} alt="" />
        {hoverSrc && <img className="hover-mask" src={hoverSrc} alt="" />}
        {alt && <span>{alt}</span>}
      </div>
    </ScrollElememt>
  )
}

export default BlockImage
